import { render, staticRenderFns } from "./BaseOfficeViewer.vue?vue&type=template&id=18fad8e1&"
import script from "./BaseOfficeViewer.vue?vue&type=script&lang=js&"
export * from "./BaseOfficeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports